// Resort Settings — displays live resort config so staff can verify what's
// used in receipts and site copy. Read-only for now (super_admin can edit env-managed
// values in a future phase).
import { Settings, MapPin, Phone, Mail, Info } from "lucide-react";

const RESORT = {
    name: "Serenity Cove Resorts",
    location: "Ocho Rios, Jamaica",
    address: "87A & 87B Mammee Bay Boulevard, Ocho Rios, Jamaica",
    phone: "+1 (876) 634-7439",
    email: "stay@serenitycoveresorts.com",
    check_in: "3:00 PM",
    check_out: "11:00 AM",
    tax_rate_pct: 15,
    resort_fee_per_night: 15,
    best_value_discount_pct: 12,
    cancellation_policy: "Free cancellation until 3 days before arrival on flexible rates. Non-refundable rates are charged in full at booking.",
    currency: "USD",
    payment_processor: "PayPal (Live)",
};

function Row({ icon: Icon, label, value }) {
    return (
        <div className="flex items-start gap-3 py-3 border-b border-navy/10 last:border-b-0">
            <div className="w-8 h-8 rounded-full bg-gold/15 text-gold flex items-center justify-center shrink-0"><Icon size={14} /></div>
            <div className="flex-1">
                <div className="text-[10px] uppercase tracking-[0.22em] text-navy/50">{label}</div>
                <div className="text-navy text-sm mt-0.5">{value}</div>
            </div>
        </div>
    );
}

export default function AdminSettings() {
    return (
        <div data-testid="admin-settings-page">
            <header className="mb-6">
                <div className="text-[10px] uppercase tracking-[0.28em] text-gold">Configuration</div>
                <h1 className="font-display text-4xl md:text-5xl text-[#0b1f22] mt-3">Resort settings</h1>
                <p className="text-[#0b1f22]/60 mt-2 text-sm">
                    Live resort configuration used in receipts, booking emails and the public site.
                </p>
            </header>

            <div className="grid md:grid-cols-2 gap-6">
                <section className="bg-white border border-navy/10 rounded-2xl p-6">
                    <div className="text-[10px] uppercase tracking-[0.22em] text-navy/60">Property</div>
                    <div className="font-display text-2xl text-navy mt-1 mb-4">Contact & location</div>
                    <Row icon={Info} label="Name" value={RESORT.name} />
                    <Row icon={MapPin} label="Address" value={RESORT.address} />
                    <Row icon={Phone} label="Phone" value={RESORT.phone} />
                    <Row icon={Mail} label="Email" value={RESORT.email} />
                    <Row icon={Info} label="Check-in / Check-out" value={`${RESORT.check_in}  /  ${RESORT.check_out}`} />
                </section>

                <section className="bg-white border border-navy/10 rounded-2xl p-6">
                    <div className="text-[10px] uppercase tracking-[0.22em] text-navy/60">Rates & policy</div>
                    <div className="font-display text-2xl text-navy mt-1 mb-4">Taxes, fees & payment</div>
                    <Row icon={Settings} label="Currency" value={RESORT.currency} />
                    <Row icon={Settings} label="Tax rate" value={`${RESORT.tax_rate_pct}%`} />
                    <Row icon={Settings} label="Resort fee" value={`$${RESORT.resort_fee_per_night} / night`} />
                    <Row icon={Settings} label="Best Value discount" value={`${RESORT.best_value_discount_pct}% off flexible`} />
                    <Row icon={Settings} label="Payment processor" value={RESORT.payment_processor} />
                    <Row icon={Info} label="Cancellation policy" value={RESORT.cancellation_policy} />
                </section>
            </div>

            <p className="mt-6 text-[12px] text-navy/50">
                These values are managed in code &amp; environment variables today. If you want an editable UI for these,
                request the Settings-editor upgrade.
            </p>
        </div>
    );
}
